import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './services/translate.service';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {
  private loaded: Boolean;
  private tempVal: string;
  constructor(private translator: TranslateService) {
    this.loaded = false;
  }

  transform(value: string, type: String = null): string {
    if (type === 'date') {
      const t = parseInt(value, 0) * 1000;
      const d = new Date(t);
      const m = d.getMonth() + 1;
      return ((d.getDate() < 10) ? '0' +
        d.getDay() : d.getDay()) + '.' + ((m < 10) ? '0' + m : m) + '.' + d.getFullYear();
    }

    return this.translator.translate(value);
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/translate.pipe.ts